import { z } from 'zod';
export const organizationLabelRoutes = {
    read: {
        method: 'GET',
        path: '/organization/:organizationId/label/:labelId',
        output: {},
    },
    list: {
        method: 'GET',
        path: '/organization/:organizationId/labels',
        q: z
            .object({
            labelGroupId: z.string().optional(),
        })
            .strict()
            .optional(),
        output: {},
    },
    listLabelGroups: {
        method: 'GET',
        path: '/organization/:organizationId/label-groups',
        output: {},
    },
    createLabel: {
        method: 'POST',
        path: '/organization/:organizationId/label',
        input: z.object({
            name: z.string(),
            color: z.string(),
            labelGroupId: z.string().nullable(),
        }),
        output: {},
    },
    createLabelGroup: {
        method: 'POST',
        path: '/organization/:organizationId/label-group',
        input: z.object({
            name: z.string(),
        }),
        output: {},
    },
    labelAssignment: {
        method: 'GET',
        path: '/organization/:organizationId/project/:projectId/assignment',
        output: {},
    },
    labelAssignments: {
        method: 'GET',
        path: '/organization/:organizationId/assignments',
        q: z
            .object({
            projectId: z.string().optional(),
            labelGroupIds: z.array(z.string()).optional(),
            labelIds: z.array(z.string()).optional(),
        })
            .strict()
            .optional(),
        output: {},
    },
    updateLabelAssignment: {
        method: 'POST',
        path: '/organization/:organizationId/project/:projectId/assignment',
        input: z.object({
            groupIds: z.array(z.string()),
            labelIds: z.array(z.string()),
        }),
        output: {},
    },
    deleteLabelAssignment: {
        method: 'DELETE',
        path: '/organization/:organizationId/project/:projectId/assignment/:projectLabelAssignmentId',
        output: {},
    },
    updateLabel: {
        method: 'PATCH',
        path: '/organization/:organizationId/labels/:labelId',
        input: z.object({
            name: z.string(),
            color: z.string(),
            labelGroupId: z.string().nullable(),
        }),
        output: {},
    },
    updateLabelGroup: {
        method: 'PATCH',
        path: '/organization/:organizationId/label-groups/:labelGroupId',
        input: z.object({
            name: z.string(),
        }),
        output: {},
    },
    deleteLabel: {
        method: 'DELETE',
        path: '/organization/:organizationId/labels/:labelId',
        output: {},
    },
    deleteLabelGroup: {
        method: 'DELETE',
        path: '/organization/:organizationId/label-groups/:labelGroupId',
        q: z.object({
            deleteLabels: z.boolean().optional(),
        }),
        output: {},
    },
};
//# sourceMappingURL=organization-label-routes.js.map